export default {
  'menu.welcome': 'Welcome',
  'menu.home': 'Home',
  'menu.back_to_home': 'Back To Application',
  'menu.dashboard': 'Dashboard',
  'menu.api-integration': 'API Integration',
  'menu.terms-and-conditions': 'Terms and Conditions',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register.result': 'Register Result',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.account.account-recovery': 'Account Recovery',
  'menu.reset-password': 'Reset Password',
  'menu.settings': 'Settings',
  'menu.privacy-policy': 'Privacy Policy',
  'menu.shipment.settings.courier-services': 'Services',
  'menu.shipment.settings.courier-services.service_edit': 'Edit Service',
  'menu.shipment.settings.customer-rate-service': 'Customer Service',
  'menu.shipment.settings.couriers': 'Couriers',
  'menu.shipment.settings.courier-platform-methods': 'Platform Service',
  'menu.shipment.settings.suppliers': 'Suppliers',
  'menu.shipment.settings.warehouses': 'Warehouses',
  'menu.shipment.settings.shipper-accounts': 'Shipper Accounts',
  'menu.shipment.quote': 'Get Quotes',
  'menu.shipment.quote.quoteImport': 'Import Quote',
  'menu.shipment.quote.quoteExport': 'Export Quote',
  'menu.shipment.quote.quoteRemotePickup': 'Remote Pickup Quote',
  'menu.shipment.quote.hongkongLocalTruck': 'Hong Kong Truck',
  'menu.shipment.download_price_list': 'Rate Card',
  'menu.shipment.download_announcement': 'Notices',
  'menu.shipment.label': 'Create Labels',
  'menu.shipment.labelCreate': 'Create Single Shipment',
  'menu.shipment.labelUpload': 'Create Multi Shipments',
  'menu.shipment.labelManage': 'Shipment Summary',
  'menu.shipment.labelManage.labelEdit': 'Edit Label',
  'menu.shipment.labelManage.pendingLabel': 'Pending',
  'menu.shipment.labelManage.rejectedLabel': 'Rejected',
  'menu.shipment.labelManage.toDownload': 'Download',
  'menu.shipment.labelManage.labelDetail': 'Label Detail',
  'menu.shipment.labelManage.wmsPreorder': 'Pre Order(WMS)',
  'menu.shipment.labelManage.wmsInProgress': 'Work In Porgress(WMS)',
  'menu.shipment.labelManage.wmsShipped': 'Shipped (WMS)',
  'menu.shipment.labelsStatus': 'Labels Status',
  'menu.shipment': 'Shipment',
  'menu.shipment.settings': 'Settings',
  'menu.shipment.label.labelCreate': 'Basic Create',
  'menu.shipment.label.labelUpload': 'Bulk Upload',
  'menu.shipment.track-trace': 'Track & Trace',
  'menu.shipment.pickup-request': 'Pick Up Requests',
  'menu.shipment.delivery-booking': 'Booking Appointment',
  'menu.shipment.delivery-booking.booking_edit': 'Edit Booking',
  'menu.shipment.shipment': 'Shipments',
  'menu.shipment.shipment.shipmentSummary': 'Shipment Summary',
  'menu.shipment.shipment.shipmentSummary.all-shipments': 'All Shipments',
  'menu.shipment.shipment.shipmentSummary.assign-shipment': 'Assign Shipment',
  'menu.shipment.shipment.shipmentSummary.upload-lastmile': 'Upload Lastmile',
  'menu.shipment.shipment.shipmentSummary.send-manifest': 'Send Manifest',
  'menu.shipment.shipment.shipmentSummary.manual-shipments': 'Manual Shipments',
  'menu.shipment.shipment.shipmentTracking': 'Shipment Tracking',
  'menu.shipment.shipment.delivery-booking': 'Booking (Re-Label) ',
  'menu.shipment.shipment.delivery-booking.booking-orders': 'Booking Orders',
  'menu.shipment.shipment.delivery-booking.prepare': 'Prepare',
  'menu.shipment.shipment.delivery-booking.scan': 'Scan',
  'menu.shipment.shipment.delivery-booking.dispatch': 'Dispatch',
  'menu.shipment.shipment.delivery-booking.upload-lastmile': 'Upload Lastmile',
  'menu.shipment.shipment.delivery-booking.send-manifest': 'Send Manifest',
  'menu.shipment.shipment.delivery-booking.booking_edit': 'Edit Booking',
  'menu.shipment.service-channel': 'Service Channel',
  'menu.shipment.warehouses': 'Warehouses',
  'menu.shipment.warehouses.warehouse-scan': 'Warehouse Scan',
  'menu.shipment.warehouses.advance-shipment-notice': 'ASN',
  'menu.shipment.warehouses.gate-charge': 'Gate Charge',
  'menu.shipment.courier-services': 'Services Channel',
  'menu.shipment.service-costs': 'System Costs',
  'menu.shipment.service-costs.services': 'System Costs',
  'menu.shipment.service-costs.effectives': 'Effectives',
  'menu.shipment.service-costs.fee-trails': 'Rates Matrix',
  'menu.shipment.service-costs.upload': 'Upload Costs',
  'menu.shipment.service-spots': 'Spots',
  'menu.shipment.service-spots.service-spot-costs': 'Spot Costs',
  'menu.shipment.service-spots.customer-spot-rates': 'Spot Quote',
  'menu.shipment.service-costs.upload-location-zone': 'Upload Location Zone',
  'menu.shipment.address-books': 'Address Book',
  'menu.shipment.manage-service': 'Manage Service',
  'menu.shipment.manage-service.courier-services': 'Courier Service',
  'menu.shipment.manage-service.courier-services.service_detail': 'Service Details',
  'menu.shipment.manage-service.customer-rate-service': 'Customer Service',
  'menu.marketplaceManage': 'Marketplace',
  'menu.marketplaceManage.order': 'Orders',
  'menu.marketplaceManage.order-fulfillment': 'Order Fulfillment',
  'menu.marketplaceManage.order-fulfillment.platform-order': 'Platform Order(All)',
  'menu.marketplaceManage.order-fulfillment.new-order': 'New Order',
  'menu.marketplaceManage.order-fulfillment.upload-to-create-label': 'Upload Order',
  'menu.marketplaceManage.order-fulfillment.ready-to-ship': 'Ready To Ship',
  'menu.marketplaceManage.order-fulfillment.shipped-order': 'Shipped Order',
  'menu.marketplaceManage.order-fulfillment.orderDetail': 'Order Detail',
  'menu.marketplaceManage.order-fulfillment.rejected-label': 'Rejected Label',
  'menu.marketplaceManage.store': 'Stores',
  'menu.marketplaceManage.marketplace-commission': 'Commission',
  'menu.marketplaceManage.marketplace-category': 'Marketplace Category',
  'menu.marketplaceManage.payment-gateway': 'Payment Gateway',
  'menu.warehouses': 'Warehouses',
  'menu.warehouses.warehouse-scan': 'Warehouse Scan',
  'menu.warehouses.advance-shipment-notice': 'ASN',
  'menu.warehouses.gate-charge': 'Gate Charge',
  'menu.warehouse-bills': 'Warehouse Bill',
  'menu.warehouse-bills.edit': 'Edit Warehouse Bill',
  'menu.service-channel': 'Service Channel',
  'menu.address-books': 'Address Books',
  'menu.productManage': 'Product Management',
  'menu.productManage.products': 'Product',
  'menu.productManage.products.edit': 'Edit Product',
  'menu.productManage.product-prices': 'Product Prices',
  'menu.productManage.inbound': 'Inbound',
  'menu.productManage.inbound.edit': 'Edit Inbound',
  'menu.productManage.rma-order': 'RMA Management',
  'menu.productManage.rma-order.edit': 'RMA Management Edit',
  'menu.productManage.outbound': 'Outbound',
  'menu.productManage.outbound.edit': 'Edit Outbound',
  'menu.productManage.inventory': 'Inventory',
  'menu.productManage.warehouse-bills': 'Warehouse Bill',
  'menu.productManage.warehouse-bills.edit': 'Edit Warehouse Bill',
  'menu.productManage.product-supplier-costs': 'Product Supplier Costs',
  'menu.productManage.report': 'Report',
  'menu.productManage.calculator-profit-jobs': 'Calculator Profit Jobs',
  'menu.productManage.calculator-profit-jobs.upload-supplier-cost-jobs':
    'Upload Supplier Cost Jobs',
  'menu.productManage.calculator-profit-jobs.update-category-commission-jobs':
    'Update Category Commission Jobs',
  'menu.productManage.calculator-profit-jobs.update-payment-commssion-jobs':
    'Update Payment Gateway Commission Jobs',
  'menu.productManage.product-category': 'Product Category',
  'menu.productManage.suppliers': 'Supplier',
  'menu.productManage.currency': 'Currency',
  'menu.productManage.exchange-rate': 'Exchange Rate',
  'menu.productManage.setting': 'Setting',
  'menu.productManage.setting.product-category': 'Product Category',
  'menu.productManage.setting.suppliers': 'Supplier',
  'menu.productManage.setting.currency': 'Currency',
  'menu.productManage.setting.merchant': 'Merchant',
  'menu.productManage.setting.exchange-rate': 'Exchange Rate',
  'menu.productManage.setting.marketplace-commission': 'Commission',
  'menu.productManage.setting.marketplace-category': 'Marketplace Category',
  'menu.productManage.setting.payment-gateway': 'Payment Gateway',
  'menu.productManage.wmsManage': 'WMS',
  'menu.productManage.line': 'Line',
  'menu.products': 'Product',
  'menu.products.edit': 'Edit Product',
  'menu.product-prices': 'Product Prices',
  'menu.product-supplier-costs': 'Product Supplier Costs',
  'menu.wms-dashboard': 'Dashboard',
  'menu.report': 'Report',
  'menu.calculator-profit-jobs': 'Calculator Profit Jobs',
  'menu.calculator-profit-jobs.upload-supplier-cost-jobs': 'Upload Supplier Cost Jobs',
  'menu.calculator-profit-jobs.update-category-commission-jobs': 'Update Category Commission Jobs',
  'menu.calculator-profit-jobs.update-payment-commssion-jobs':
    'Update Payment Gateway Commission Jobs',
  'menu.setting': 'Setting',
  'menu.setting.product-category': 'Product Category',
  'menu.setting.merchant': 'Merchant',
  'menu.setting.suppliers': 'Supplier',
  'menu.setting.currency': 'Currency',
  'menu.setting.exchange-rate': 'Exchange Rate',
  'menu.setting.marketplace-commission': 'Commission',
  'menu.setting.marketplace-category': 'Marketplace Category',
  'menu.setting.payment-gateway': 'Payment Gateway',
  'menu.product-category': 'Product Category',
  'menu.suppliers': 'Supplier',
  'menu.currency': 'Currency',
  'menu.exchange-rate': 'Exchange Rate',
  'menu.marketplace-commission': 'Commission',
  'menu.marketplace-category': 'Marketplace Category',
  'menu.payment-gateway': 'Payment Gateway',

  'menu.wmsManage': 'WMS',
  'menu.wmsManage.wms-dashboard': 'Dashboard',
  'menu.wmsManage.inbound.asn': 'ASN',
  'menu.wmsManage.inbound.inspection': 'Inspection',
  'menu.wmsManage.inbound.sorting': 'Sorting',
  'menu.wmsManage.inbound.print-label': 'Print Label',
  'menu.wmsManage.inbound.sorting-report': 'Sorting Report',
  'menu.wmsManage.inbound.put-away': 'Put Away',
  'menu.wmsManage.inbound.upload-receiving': 'Upload Receiving',
  'menu.wmsManage.inventoryManage.edit-stocktake': 'Edit Stock Take',
  'menu.wmsManage.inbound': 'Inbound',
  'menu.wmsManage.inbound.edit': 'Edit Inbound',
  'menu.wmsManage.amr-replenishment': 'AMR Replenishment',
  'menu.wmsManage.amr-replenishment.create': 'Create AMR Replenishment',
  'menu.wmsManage.amr-replenishment.movement-temp-zone': 'Movement Temp Zone',
  'menu.wmsManage.amr-replenishment.products': 'AMR Replenishment Products',
  'menu.wmsManage.amr-replenishment.edit': 'Edit AMR Replenishment',
  'menu.wmsManage.amr-replenishment.picking': 'Picking AMR Replenishment',
  'menu.wmsManage.amr-replenishment.received': 'Received AMR Replenishment',
  'menu.wmsManage.amr-replenishment.request-items': 'Request Items',
  'menu.wmsManage.amr-replenishment.return': 'Return Cancelled AMR Order',
  'menu.wmsManage.amr-replenishment.replenishment-orders': 'Replenishment Orders',
  'menu.wmsManage.report': 'Report',
  'menu.wmsManage.tools': 'Tools',
  'menu.wmsManage.tools.print-container': 'Print Container',
  'menu.wmsManage.tools.print-offline-inbound': 'Print Offline Inbound',
  'menu.wmsManage.tools.print-outbound-carton': 'Print Outbound Carton',
  'menu.wmsManage.tools.print-warehouse-trolley': 'Print Warehouse Trolley',
  'menu.wmsManage.outbound.dashboard': 'Outbound Dashboard',
  'menu.wmsManage.outbound': 'Outbound',
  'menu.wmsManage.outbound.edit': 'Edit Outbound',
  'menu.wmsManage.outbound.amr-pick-order': 'AMR Picking Order',
  'menu.wmsManage.outbound.no-amr-pick-order': 'Non-AMR Picking Order',
  'menu.wmsManage.outbound.deliveryNote': 'Delivery Note',
  'menu.wmsManage.outbound.packlist': 'Packlist',
  'menu.wmsManage.outbound.dispatch': 'Order - Dispatch',
  'menu.wmsManage.outbound.upload-dispatch': 'Upload Dispatch',
  'menu.wmsManage.outbound.new-order': 'New Order',
  'menu.wmsManage.outbound.amr-release-container': 'Release Container',
  'menu.wmsManage.outbound-pick': 'Order - Pick',
  'menu.wmsManage.outbound-pick.amr-picklist': 'AMR - Picklist',
  'menu.wmsManage.outbound-pick.no-amr-picklist': 'Non-AMR - Picklist',
  'menu.wmsManage.outbound-pick.no-amr-pick': 'Non-AMR - Pick',
  'menu.wmsManage.outbound-pick.no-amr-container-pick': 'Non-AMR(Container) - Pick',
  'menu.wmsManage.outbound-pack': 'Order - Pack',
  'menu.wmsManage.outbound-pack.pack-order': 'Pack Order',
  'menu.wmsManage.outbound-pack.scan-to-pack': 'Scan To Pack',
  'menu.wmsManage.outbound-pack.pack-waybill': 'Print Packed Waybill',
  'menu.wmsManage.outbound-pack.no-amr-pick-pack': 'Non-AMR - Pick & Pack',
  'menu.wmsManage.outbound-pack.reprint': 'Re-Print',
  'menu.wmsManage.outbound-pack.reinput-weight': 'Re-Input Weight & Dimension',
  'menu.wmsManage.outbound-dispatch': 'Order - Dispatch',
  'menu.wmsManage.outbound-dispatch.amr-dispatch': 'AMR - Dispatch',
  'menu.wmsManage.outbound-dispatch.no-amr-dispatch': 'Non-AMR - Dispatch',
  'menu.wmsManage.outbound-return': 'Order - Return',
  'menu.wmsManage.outbound-return.return': 'Return To Non-AMR',
  'menu.wmsManage.outbound-return.return-orders': 'Return Orders',
  'menu.wmsManage.outbound-return.put-away': 'Put Away',
  'menu.wmsManage.outbound-return.new-item': 'Return Items',
  'menu.wmsManage.outbound-dispatch.common-dispatch': 'Dispatch',
  'menu.wmsManage.outbound-dispatch.manifest': 'Manifest',

  'menu.wmsManage.pickPackVas': 'Pick & Pack VAS',
  'menu.wmsManage.pickPackVas.marketplace': 'Marketplace',
  'menu.wmsManage.pickPackVas.pick-pack-vas-flow': 'Pick & Pack VAS Flow',
  'menu.wmsManage.pickPackVas.marketplace-pick-pack-vas': 'Marketplace Pick & Pack VAS',
  'menu.wmsManage.outbound-console': 'Outbound Console',
  'menu.wmsManage.outbound-console.console': 'Console',
  'menu.wmsManage.outbound-console.create': 'Create Console',
  'menu.wmsManage.outbound-console.edit': 'Edit Outbound Console',
  'menu.wmsManage.outbound-console.dispatch': 'Dispatch Console',
  'menu.wmsManage.outbound-console.console-order': 'Console Order',
  'menu.wmsManage.transfer-pick-order': 'Transfer Order',
  'menu.wmsManage.transfer-pick-order.new-transfer': 'Transfer Order',
  'menu.wmsManage.transfer-pick-order.no-amr-pick': 'Non-AMR Pick Transfer Order',
  'menu.wmsManage.transfer-pick-order.sorting': 'Sorting Transfer Order',
  'menu.wmsManage.transfer-pick-order.put-away': 'Put Away Transfer Order',
  'menu.wmsManage.transfer-pick-order.sorting-report': 'Sorting Report Transfer Order',
  'menu.wmsManage.transfer-pick-order.edit': 'Edit Transfer Order',
  'menu.wmsManage.products': 'Products',
  'menu.wmsManage.products.wms-provider-products': 'WMS Provider Products',
  'menu.wmsManage.products.edit': 'Edit Product',
  'menu.wmsManage.inventory': 'Inventory',
  'menu.wmsManage.warehouseSetting': 'Warehouse Setting',
  'menu.wmsManage.warehouseSetting.warehouses': 'Warehouse',
  'menu.wmsManage.warehouseSetting.warehouses.warehouse_edit': 'Warehouse Edit',
  'menu.wmsManage.warehouseSetting.virtual-warehouses': 'Virtual Warehouse',
  'menu.wmsManage.warehouseSetting.warehouse-zone': 'Warehouse Zone',
  'menu.wmsManage.warehouseSetting.warehouse-bin': 'Warehouse Bin',
  'menu.wmsManage.warehouseSetting.warehouse-bin-size': 'Bin Size',
  'menu.wmsManage.drivers': 'Drivers',
  'menu.wmsManage.merchants': 'Merchants',
  'menu.wmsManage.line': 'Line',
  'menu.wmsManage.productManage': 'Product Management',
  'menu.wmsManage.client-webhooks': 'Client Webhooks',
  'menu.inbound': 'Inbound',
  'menu.inbound.edit': 'Edit Inbound',
  'menu.inbound.asn': 'ASN',
  'menu.inbound.inspection': 'Inspection',
  'menu.inbound.sorting': 'Sorting',
  'menu.inbound.print-label': 'Print Label',
  'menu.inbound.sorting-report': 'Sorting Report',
  'menu.inbound.put-away': 'Put Away',
  'menu.inbound.upload-receiving': 'Upload Receiving',
  'menu.amr-replenishment': 'AMR Replenishment',
  'menu.amr-replenishment.create': 'Create AMR Replenishment',
  'menu.amr-replenishment.movement-temp-zone': 'Movement Temp Zone',
  'menu.amr-replenishment.products': 'AMR Replenishment Products',
  'menu.amr-replenishment.return': 'Return DN',
  'menu.amr-replenishment.edit': 'Edit AMR Replenishment',
  'menu.amr-replenishment.picking': 'Picking AMR Replenishment',
  'menu.amr-replenishment.received': 'Received AMR Replenishment',
  'menu.amr-replenishment.request-items': 'Request Items',
  'menu.amr-replenishment.replenishment-orders': 'Replenishment Orders',
  'menu.tools': 'Tools',
  'menu.tools.print-container': 'Print Container',
  'menu.tools.print-offline-inbound': 'Print Offline Inbound',
  'menu.tools.print-warehouse-trolley': 'Print Warehouse Trolley',
  'menu.rma-order': 'RMA Management',
  'menu.rma-order.edit': 'RMA Management Edit',
  'menu.outbound.dashboard': 'Outbound Dashboard',
  'menu.outbound': 'Outbound',
  'menu.outbound.edit': 'Edit Outbound',
  'menu.outbound.amr-pick-order': 'AMR Picking Order',
  'menu.outbound.no-amr-pick-order': 'Non-AMR Picking Order',
  'menu.outbound.deliveryNote': 'Delivery Note',
  'menu.outbound.packlist': 'Packlist',
  'menu.outbound.dispatch': 'Order - Dispatch',
  'menu.outbound.upload-dispatch': 'Upload Dispatch',
  'menu.outbound.new-order': 'New Order',
  'menu.outbound.amr-release-container': 'Release Container',
  'menu.outbound.transfer-pending-outbound': 'Pending Outbound',
  'menu.outbound-pick': 'Order - Pick',
  'menu.outbound-pick.amr-picklist': 'AMR - Picklist',
  'menu.outbound-pick.no-amr-picklist': 'Non-AMR - Picklist',
  'menu.outbound-pick.no-amr-pick': 'Non-AMR - Pick',
  'menu.outbound-pick.no-amr-container-pick': 'Non-AMR(Container) - Pick',
  'menu.outbound-pack': 'Order - Pack',
  'menu.outbound-pack.pack-order': 'Pack Order',
  'menu.outbound-pack.scan-to-pack': 'Scan To Pack',
  'menu.outbound-pack.pack-waybill': 'Print Packed Waybill',
  'menu.outbound-pack.no-amr-pick-pack': 'Non-AMR - Pick & Pack',
  'menu.outbound-pack.reprint': 'Re-Print',
  'menu.outbound-pack.reinput-weight': 'Re-Input Weight & Dimension',
  'menu.outbound-dispatch': 'Order - Dispatch',
  'menu.outbound-dispatch.amr-dispatch': 'AMR - Dispatch',
  'menu.outbound-dispatch.no-amr-dispatch': 'Non-AMR - Dispatch',
  'menu.outbound-return': 'Order - Return',
  'menu.outbound-return.return': 'Return To Non-AMR',
  'menu.outbound-return.put-away': 'Put Away',
  'menu.outbound-return.return-orders': 'Return Orders',
  'menu.outbound-return.new-item': 'Return Items',
  'menu.outbound-dispatch.common-dispatch': 'Dispatch',
  'menu.outbound-dispatch.manifest': 'Manifest',

  'menu.pickPackVas': 'Pick & Pack VAS',
  'menu.pickPackVas.marketplace': 'Marketplace',
  'menu.pickPackVas.pick-pack-vas-flow': 'Pick & Pack VAS Flow',
  'menu.pickPackVas.marketplace-pick-pack-vas': 'Marketplace Pick & Pack VAS',
  'menu.outbound-console': 'Outbound Console',
  'menu.outbound-console.console': 'Console',
  'menu.outbound-console.create': 'Create Console',
  'menu.outbound-console.dispatch': 'Dispatch Console',
  'menu.outbound-console.console-order': 'Console Order',
  'menu.transfer-pick-order': 'Transfer Order',
  'menu.transfer-pick-order.new-transfer': 'Transfer Order',
  'menu.transfer-pick-order.no-amr-pick': 'Non-AMR Pick Transfer Order',
  'menu.transfer-pick-order.sorting': 'Sorting Transfer Order',
  'menu.transfer-pick-order.put-away': 'Put Away Transfer Order',
  'menu.transfer-pick-order.edit': 'Edit Transfer Order',
  'menu.inventory': 'Inventory',
  'menu.stocktake': 'Non-AMR - Stock Take',
  'menu.batch-property-adjustment': 'Batch Adjustment',
  'menu.inventoryManage': 'Stock Management',
  'menu.inventoryManage.edit-stocktake': 'Edit Stock Take',
  'menu.inventoryManage.stock': 'Stock',
  'menu.inventoryManage.stock-product-type': 'Stock Product Type',
  'menu.inventoryManage.stocktake': 'Stock Take',
  'menu.inventoryManage.inventory-adjustments': 'Inventory Adjustments',
  'menu.inventoryManage.edit-inventory-adjustment': 'Edit Inventory Adjustment',
  'menu.inventoryManage.batch-property-adjustment': 'Batch Property Adjustment',
  'menu.inventoryManage.edit-batch-adjustment': 'Edit Batch Adjustment',
  'menu.inventoryManage.edit-batch-property-adjustment-item': 'Edit Batch Property Adjustment Item',
  'menu.inventoryManage.batch-property-adjustment-item': 'Batch Property Adjustment Items',
  'menu.inventoryManage.inventory': 'Stock List',
  'menu.inventoryManage.inventory-bin': 'Bin List',
  'menu.inventoryManage.temp-inventory': 'Temp Zone Stock',
  'menu.inventoryManage.inventory-cycle-count': 'Cycle Count',
  'menu.inventoryManage.bin-lock-setting': 'Bin Lock Setting',
  'menu.wmsManage.inventoryManage': 'Stock Management',
  'menu.wmsManage.inventoryManage.inventory': 'Stock List',
  'menu.wmsManage.inventoryManage.inventory-bin': 'Bin List',
  'menu.wmsManage.inventoryManage.inventory-cycle-count': 'Cycle Count',
  'menu.wmsManage.inventoryManage.stock': 'Stock',
  'menu.wmsManage.inventoryManage.stock-product-type': 'Stock Product Type',
  'menu.wmsManage.inventoryManage.stocktake': 'Stock Take',
  'menu.wmsManage.inventoryManage.inventory-adjustments': 'Inventory Adjustments',
  'menu.wmsManage.inventoryManage.edit-inventory-adjustment': 'Edit Inventory Adjustment',
  'menu.wmsManage.inventoryManage.edit-batch-adjustment': 'Edit Batch Adjustment',
  'menu.wmsManage.inventoryManage.batch-property-adjustment': 'Batch Property Adjustments',
  'menu.wmsManage.inventoryManage.batch-property-adjustment-item':
    'Batch Property Adjustment Items',
  'menu.warehouseSetting': 'Warehouse Setting',
  'menu.warehouseSetting.warehouses': 'Warehouse',
  'menu.warehouseSetting.warehouses.warehouse_edit': 'Warehouse Edit',
  'menu.warehouseSetting.virtual-warehouses': 'Virtual Warehouse',
  'menu.warehouseSetting.warehouse-zone': 'Warehouse Zone',
  'menu.warehouseSetting.warehouse-bin': 'Warehouse Bin',
  'menu.warehouseSetting.warehouse-bin-size': 'Bin Size',
  'menu.wmsManage.rma-order': 'RMA Order',
  'menu.wmsManage.rma-order.edit': 'RMA Order Edit',
  'menu.settlementCenter': 'Settlement Center',
  'menu.settlementCenter.company-wms-quotations.edit': 'Edit Wms Quotation',
  'menu.wmsManage.settlementCenter': 'Settlement Center',
  'menu.wmsManage.settlementCenter.company-wms-quotations': 'WMS Quotation',
  'menu.wmsManage.settlementCenter.company-wms-quotations.edit': 'Edit WMS Quotation',
  'menu.wmsManage.settlementCenter.bill-manage': 'Bill Management',
  'menu.wmsManage.settlementCenter.bill-manage.edit': 'Edit Warehouse Bill',
  'menu.wmsManage.settlementCenter.bill-manage.warehouse-bills': 'Warehouse Bill',
  'menu.wmsManage.settlementCenter.bill-manage.warehouse-bills.edit': 'Edit Warehouse Bill',
  'menu.wmsManage.settlementCenter.bill-manage.warehouse-rent-bills': 'Warehouse Rent Bill',
  'menu.wmsManage.settlementCenter.bill-manage.warehouse-rent-bill-items': 'Warehouse Rent',
  'menu.wmsManage.settlementCenter.bill-manage.inbound-charges': 'Inbound Charges',
  'menu.wmsManage.settlementCenter.bill-manage.outbound-charges': 'Outbound Charges',

  'menu.settlementCenter.company-wms-quotations': 'WMS Quotation',
  'menu.settlementCenter.bill-manage': 'Bill Management',
  'menu.settlementCenter.bill-manage.warehouse-bills': 'Bill Management',
  'menu.settlementCenter.bill-manage.warehouse-bills.edit': 'Edit Bill Management',
  'menu.settlementCenter.bill-manage.warehouse-rent-bills': 'Warehouse Rent Bill',
  'menu.settlementCenter.bill-manage.warehouse-rent-bill-items': 'Warehouse Rent',
  'menu.settlementCenter.bill-manage.inbound-charges': 'Inbound Charges',
  'menu.settlementCenter.bill-manage.outbound-charges': 'Outbound Charges',

  'menu.client-webhooks': 'Client Webhooks',
  'menu.drivers': 'Drivers',
  'menu.merchants': 'Merchants',
  'menu.line': 'Line',
  'menu.administration': 'Administration',
  'menu.administration.role': 'Role',
  'menu.administration.user': 'User',
  'menu.administration.subsidiary': 'Subsidiary',
  'menu.payment': 'Billing & Payment',
  'menu.payment.topup': 'Top-Up',
  'menu.payment.invoice': 'Invoices',
  'menu.payment.customer-payment-record': 'Payment',
  'menu.payment.create-customer-payment-record': 'Create Payment',
};
